import React, {useContext} from "react"

export const ScenarioEditorContext = React.createContext({
    scenario: undefined,
    updateScenarioFld: undefined,
    problems: undefined,
    solutions: undefined,
    actions: undefined,
    uniqueIDs: undefined,
    uniqueLabels: undefined,
    saveScenario: undefined,
    scenarioType: undefined
})

export const useScenarioEditor = () => useContext(ScenarioEditorContext)
